import { Router as _Router } from "../vendor/api.js"; // Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 74943, offsets 196536:199829. Structure and names inferred from code, not screenshots.
import * as React from "react";
import { openUnarchivedRoute } from "../platform/navigation.js";
import * as GetLanguageModule from "../i18n/getLanguage.js";
import r from "../content/extracted/74943-r.json";
let s = new Set(
  (r.paths || []).map((e) => `/docs/${e.replaceAll(/^\/+|\/+$/gu, "")}`),
);
function c(e, t) {
  let i,
    n =
      ((i =
        "string" == typeof e
          ? e.split("#")[0].split("?")[0] || "/"
          : e.pathname || "/").startsWith("/")
        ? i
        : `/${i}`
      ).replace(/\/$/u, "") || "/";
  if (!s.has(n)) return false;
  let o = (function (e) {
    var t;
    let i,
      n,
      o = e.replace(/^\/docs\//u, "").replaceAll(/^\/+|\/+$/gu, ""),
      a = r.navigateByPath?.[o];
    return a
      ? ((t = (0, GetLanguageModule.getLanguage)()),
        (i = (0, a.cnNavigate)),
        (n = i?.[t]) ? String(n) : null)
      : null;
  })(n);
  return (
    !!o &&
    (t?.replace === false
      ? window.location.assign(o)
      : window.location.replace(o),
    true)
  );
}
function d(e, t) {
  return t && 0 !== t.length
    ? t.some((t) =>
        "string" == typeof t ? e.startsWith(t) || e === t : t.test(e),
      )
    : e.startsWith("/console") || "/contact" === e || "/profile" === e;
}
function u(e) {
  return `${window.location.origin}/api/v1/genLoginUrl?${new URLSearchParams({
    currentPath: e,
  }).toString()}`;
}
function ArchiveRouter({
  children: children,
  basename: t = "",
  authRequiredPaths: authRequiredPaths,
  enableAuthCheck: r = true,
  ...l
}) {
  let s = (0, React.useCallback)(() => {
      let e = window.location.pathname;
      t && e.startsWith(t) && (e = e.slice(t.length) || "/");
      let i = window.history.state;
      return {
        pathname: e,
        search: window.location.search,
        hash: window.location.hash,
        state: i?.usr ?? null,
        key: "default",
      };
    }, [t]),
    [m, h] = (0, React.useState)(s),
    g = (0, React.useCallback)(() => {
      h(s());
    }, [s]),
    f = (0, React.useMemo)(
      () => ({
        createHref: (e) => {
          let i = "string" == typeof e ? e : e.pathname || "/",
            n = "string" == typeof e ? "" : e.search || "",
            o = "string" == typeof e ? "" : e.hash || "";
          return t + (i.startsWith("/") ? i : `/${i}`) + n + o;
        },
        push: (e, n) => {
          let o = "string" == typeof e ? e : e.pathname || "/",
            a = "string" == typeof e ? "" : e.search || "",
            l = "string" == typeof e ? "" : e.hash || "";
          if (
            c(e, {
              replace: false,
            })
          )
            return;
          let s = t + (o.startsWith("/") ? o : `/${o}`) + a + l;
          if (openUnarchivedRoute(s)) return;
          if (r && d(o, authRequiredPaths) && 1) {
            window.location.href = u(s);
            return;
          }
          (window.history.pushState(
            {
              usr: n,
            },
            "",
            s,
          ),
            g());
        },
        replace: (e, n) => {
          let o = "string" == typeof e ? e : e.pathname || "/",
            a = "string" == typeof e ? "" : e.search || "",
            l = "string" == typeof e ? "" : e.hash || "";
          if (c(e)) return;
          let s = t + (o.startsWith("/") ? o : `/${o}`) + a + l;
          if (openUnarchivedRoute(s, true)) return;
          if (r && d(o, authRequiredPaths) && 1) {
            window.location.href = u(s);
            return;
          }
          (window.history.replaceState(
            {
              usr: n,
            },
            "",
            s,
          ),
            g());
        },
        go: (e) => {
          window.history.go(e);
        },
        listen: (e) => (
          window.addEventListener("popstate", e),
          () => {
            window.removeEventListener("popstate", e);
          }
        ),
      }),
      [t, g, r, authRequiredPaths],
    );
  (0, React.useEffect)(() => {
    g();
    let e = () => {
      if (!c(s().pathname)) {
        if (r && d(s().pathname, authRequiredPaths) && 1) {
          let e =
            window.location.pathname +
            window.location.search +
            window.location.hash;
          window.location.href = u(e);
          return;
        }
        g();
      }
    };
    e();
    let t = () => {
      e();
    };
    window.addEventListener("popstate", t);
    let n = window.history.pushState,
      o = window.history.replaceState;
    return (
      (window.history.pushState = function (...t) {
        (n.apply(window.history, t), e());
      }),
      (window.history.replaceState = function (...t) {
        (o.apply(window.history, t), e());
      }),
      () => {
        (window.removeEventListener("popstate", t),
          (window.history.pushState = n),
          (window.history.replaceState = o));
      }
    );
  }, [g, s, r, authRequiredPaths]);
  let { location: location, ...y } = l;
  return c(s().pathname) ? null : (
    <_Router navigator={f} location={m} {...y}>
      {children}
    </_Router>
  );
}
export { ArchiveRouter };
